module.exports = __webpack_public_path__ + "static/media/Mobileback.4c3674bf.svg";